/**
 * Crea el fondo del BlackJack
 * @param {*} scene 
 */
export function crearFondo(scene) {
  scene.fondo = scene.add.image(500, 250, "fondo");
  scene.fondo.setDepth(-100);
}